import { colors } from "constants/theme"

export default function IconClose(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props.width ?? "17.469"} height={props.height ?? "17.414"} viewBox="0 0 17.469 17.414">
            <path d="M16.053 5.642 9.61 12.031l6.443 6.389-1.611 1.611L8 13.642l-6.389 6.389L0 18.42l6.389-6.389L0 5.642l1.611-1.611L8 10.42l6.443-6.389z" transform="translate(.707 -3.324)" style={{ fill: props.color ?? colors.themeSecondColor, stroke: props.color ?? colors.themeSecondColor }} />
        </svg>
    )
}
